export const faqFn = () => {
  const faq = document.querySelector(".faq");
  if (!faq) return;

  const faqItemHeight = faq.getAttribute("data-faq-item-height") || 50;
  const firstAlwaysActive = faq.getAttribute("data-faq-first-active") === "1";
  const faqItems = faq.querySelectorAll(".faq__item");

  const toggleFaq = (item, faqItems) => {
    faqItems.forEach((elem) => {
      if (item !== elem) {
        elem.classList.remove("opened");
        elem.style.height = `${faqItemHeight}px`;
      }
    });

    if (!item.classList.contains("opened")) {
      item.classList.add("opened");
      item.style.height = "auto";

      const height = item.clientHeight + "px";

      item.style.height = `${faqItemHeight}px`;

      setTimeout(() => {
        item.style.height = height;
      }, 0);
    } else {
      item.style.height = `${faqItemHeight}px`;

      item.addEventListener(
        "transitionend",
        function () {
          item.classList.remove("opened");
        },
        { once: true }
      );
    }
  };

  faqItems.forEach((item) => {
    item.addEventListener("click", () => toggleFaq(item, faqItems));
  });

  // Otwieramy pierwszy item jeśli opcja w ACF jest włączona
  if (firstAlwaysActive && faqItems.length > 0) {
    toggleFaq(faqItems[0], faqItems);
  }
};
